'use client'

import React from 'react'
import {
  FacebookShareButton,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share'

const iconSize = 40

export interface ShareButtonsProps {
  url: string
  emailSubject: string
}

function addTrailingSlash(url: string) {
  if (typeof url !== 'string' || url.length === 0) {
    return url
  }
  try {
    const urlObject = new URL(url)
    if (!urlObject.pathname.endsWith('/')) {
      urlObject.pathname += '/'
    }
    return urlObject.toString()
  } catch {
    return url
  }
}

export function ShareButtons({ url, emailSubject }: ShareButtonsProps) {
  // See readme about Google Tag Manager data ownership
  const googleAnalyticsTrackingLabelForFacebookShare = 'articles-facebook-share'
  const googleAnalyticsTrackingLabelForTwitterShare = 'articles-twitter-share'
  const googleAnalyticsTrackingLabelForEmailShare = 'articles-email-share'

  url = addTrailingSlash(url)

  return (
    <div className="my-4 flex justify-center space-x-4 md:justify-start">
      <FacebookShareButton
        className={googleAnalyticsTrackingLabelForFacebookShare}
        url={url}
      >
        <FacebookIcon size={iconSize} round />
      </FacebookShareButton>
      <TwitterShareButton
        className={googleAnalyticsTrackingLabelForTwitterShare}
        url={url}
      >
        <TwitterIcon size={iconSize} round />
      </TwitterShareButton>
      <EmailShareButton
        className={googleAnalyticsTrackingLabelForEmailShare}
        subject={emailSubject}
        url={url}
      >
        <EmailIcon size={iconSize} round bgStyle={{ fill: '#2F75EC' }} />
      </EmailShareButton>
    </div>
  )
}
